import { gql } from "@apollo/client";

const GET_SELLER_DATA = gql`
  query SellerData($input: GetSellerData!) {
    getSellerData(input: $input) {
      data {
        email {
          address
          verified
        }
        register {
          desc
          title
        }
        _id
        isOtp
        logo
        loginText
        brandName
        footerText
        style {
          header {
            color
            font
          }
          button {
            color
            font
          }
        }
        plan {
          code
          isBranding
          name
        }
        isHideMcInfo
        brand {
          termsLink
          policyLink
          favicon {
            imageUrl
            imageId
          }
        }
        isProductDiscovery
      }
      status
      error
    }
  }
`;

export default GET_SELLER_DATA;
